import Angular from "angular";
import Template from "./booking-item.html";

export default Angular.module('booking-item', [])
    .component('bookingItem', {
        template: Template,
        bindings: {
            booking: '<',
            showDate: '<',
            iconRight: '@'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-item/booking-item.js